import store from '../store';
import { logoutUser } from '../store/actions';
import { history } from '../store/reducers';

export const requestIsOk = (response, scope) => {
  if (!response.ok) {
    const url = response.url.split('/');
    if (url[url.length - 1] !== 'playerlist') {
      // store.dispatch(changeMessageLoading(scope, `${response.status} (${response.statusText})`));
    }
    throw Error(response.statusText);
  }
  return response.json();
};

export const valid = (jsonText, scope) => {
  if (+jsonText.code === -1) {
    // store.dispatch(changeMessageLoading(scope, `(200) ${jsonText.status}`));
    return null;
  }
  if (+jsonText.code === 1103) {
    history.push('/');
    return null;
  }
  if (+jsonText.code === 1102  ) { // || +jsonText.code === 1104 taking out the 1104 loggin out issue
    store.dispatch(logoutUser());
    localStorage.removeItem('user-token');
    return null;
  }
  return jsonText.results;
};

export const catchError = (err, signal) => {
  if ((signal && signal.aborted) || err === 'DOMException: "The operation was aborted.') {
    return null;
  }
  // store.dispatch(logoutUser());
  // localStorage.removeItem('user-token');
  console.error('Fetch Error: ', err);
  return null;
};
